import { parsePhoneNumberFromString } from 'libphonenumber-js';

/**
 * Formats a phone number to French national format.
 * Returns an empty string for undefined, empty, or invalid inputs.
 * @example formatPhoneFr("+33612345678") => "06 12 34 56 78"
 * @param rawPhone - The phone number to format.
 * @returns The formatted phone number.
 */
export const formatPhone = (
	rawPhone: string | number | null | undefined
): string => {
	if (!rawPhone) return '';
	const phoneText = String(rawPhone).trim();
	if (phoneText === '') return '';

	const phoneNumber = parsePhoneNumberFromString(phoneText, 'FR');
	// biome-ignore lint/complexity/useOptionalChain: Init Biome
	if (!phoneNumber || !phoneNumber.isValid()) return String(rawPhone);

	return phoneNumber.formatNational();
};

/**
 * Validates a phone number for France.
 * Returns false for undefined, empty, or invalid inputs.
 * @example isValidPhoneFr("+33612345678") => true
 * @example isValidPhoneFr("06 12 34 56 78") => true
 * @example isValidPhoneFr("+3361234567834546467") => false
 * @param rawPhone - The phone number to validate.
 * @returns True if the phone number is valid, false otherwise.
 */
export const isValidPhone = (rawPhone: string | null | undefined): boolean => {
	if (!rawPhone) return false;
	const phoneText = String(rawPhone).trim();
	if (phoneText === '') return false;

	const phoneNumber = parsePhoneNumberFromString(phoneText, 'FR');

	// biome-ignore lint/complexity/useOptionalChain: Init Biome
	return Boolean(phoneNumber && phoneNumber.isValid());
};
